module.exports = __webpack_public_path__ + "assets/waf-half.02b0e6a3.svg";